import { i18next } from "@translations/invenio_rdm_records/i18next";
import { Formik } from "formik";
import Overridable from "react-overridable";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { ErrorMessage } from "react-invenio-forms";
import { Button, Icon, Message, Modal } from "semantic-ui-react";

class SubmitReviewModalComponent extends Component {
  constructor(props) {
    super(props);
    const { initialReviewComment } = props;

    this.initialValues = {
      reviewComment: initialReviewComment || "",
    };
  }

  getModalContent = (record, directPublish, communityTitle) => {
    const modalContent = {
      headerTitle: i18next.t("Submit for review"),
      msgWarningTitle: i18next.t(
        "Please confirm that you want to submit this record for review."
      ),
      submitBtnLbl: i18next.t("Submit record for review"),
      confirmationText: i18next.t(
        "By clicking Accept, you agree to submit your record for community review."
      ),
    };

    if (record?.is_published) {
      modalContent["headerTitle"] = i18next.t("Submit to community");
      modalContent["msgWarningTitle"] = i18next.t(
        "Please confirm that you want to submit this record to the community."
      );
      modalContent["submitBtnLbl"] = i18next.t("Submit to community");
      modalContent["confirmationText"] = i18next.t(
        "This will make your record visible to community curators."
      );
    } else if (directPublish) {
      modalContent["headerTitle"] = i18next.t("Publish to community");
      modalContent["msgWarningTitle"] = i18next.t(
        "Please confirm that you want to publish this record to the community."
      );
      modalContent["submitBtnLbl"] = i18next.t("Publish record to community");
      modalContent["confirmationText"] = i18next.t(
        "Your record will be immediately published in '{{communityTitle}}'. You will still be able to modify metadata and files.",
        { communityTitle }
      );
    }

    return modalContent;
  };

  render() {
    const {
      isConfirmModalOpen,
      community,
      onClose,
      onSubmit,
      directPublish,
      errors,
      loading,
      record,
    } = this.props;

    const communityTitle = community?.metadata?.title || "";
    const modalContent = this.getModalContent(record, directPublish, communityTitle);

    return (
      <Formik
        initialValues={this.initialValues}
        onSubmit={onSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ handleSubmit }) => (
          <Modal
            open={isConfirmModalOpen}
            onClose={onClose}
            size="small"
            closeIcon
            closeOnDimmerClick={false}
          >
            <Modal.Header>{modalContent.headerTitle}</Modal.Header>
            <Modal.Content>
              {errors && (
                <ErrorMessage
                  header={i18next.t("Unable to submit request.")}
                  content={errors}
                  icon="exclamation"
                  negative
                />
              )}
              <Message visible warning>
                <p>
                  <Icon name="warning sign" />
                  {modalContent.msgWarningTitle}
                </p>
              </Message>

              <p style={{ fontSize: "1.1em", marginTop: "1rem" }}>
                {modalContent.confirmationText}
              </p>
            </Modal.Content>

            <Modal.Actions>
              <Button
                onClick={onClose}
                floated="left"
                loading={loading}
                disabled={loading}
              >
                {i18next.t("Cancel")}
              </Button>

              <Button
                name="submitReview"
                onClick={(event) => handleSubmit(event)}
                loading={loading}
                disabled={loading}
                positive={directPublish}
                primary={!directPublish}
                content={i18next.t("Accept")}
              />
            </Modal.Actions>
          </Modal>
        )}
      </Formik>
    );
  }
}

SubmitReviewModalComponent.propTypes = {
  isConfirmModalOpen: PropTypes.bool.isRequired,
  community: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialReviewComment: PropTypes.string,
  directPublish: PropTypes.bool,
  errors: PropTypes.string,
  loading: PropTypes.bool,
  record: PropTypes.object.isRequired,
};

SubmitReviewModalComponent.defaultProps = {
  initialReviewComment: "",
  directPublish: false,
  errors: "",
  loading: false,
};

export const SubmitReviewModal = Overridable.component(
  "InvenioRdmRecords.SubmitReviewModal.container",
  SubmitReviewModalComponent
);
